var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentMan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.64,242.33a2.55,2.55,0,1,1-4.38,0h-2.95a2.58,2.58,0,0,1,.36,1.29,2.55,2.55,0,1,1-4.74-1.29h-3a2.48,2.48,0,0,1,.36,1.29,2.55,2.55,0,1,1-4.74-1.29h-2.95a2.48,2.48,0,0,1,.36,1.29,2.55,2.55,0,1,1-5.09,0,2.48,2.48,0,0,1,.36-1.29h-2.95a2.55,2.55,0,1,1-4.74,1.29,2.48,2.48,0,0,1,.36-1.29H169a2.55,2.55,0,1,1-4.38,0h-1.85V295h43.84V242.33Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.13,329.84a16.4,16.4,0,0,1,16-13.77c34.54-.46,122.48-1.25,127.2,2.49,5.88,4.67,9,7.06,8.49,14.47-.43,6.8-7.84,124.29-7.84,124.29H438.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.2,457.38a2.49,2.49,0,0,1-.05-.35c0-.25,0-.59-.08-1-.07-.92-.17-2.24-.29-3.91s-.26-3.79-.34-6.21-.24-5.18-.24-8.23c0-1.53,0-3.13-.05-4.79s0-3.4.06-5.19c0-3.59.21-7.42.38-11.45.46-8.06,1.22-16.9,2.45-26.13s2.91-18,4.62-25.85c.91-3.93,1.75-7.67,2.69-11.14.46-1.73.87-3.41,1.33-5s.91-3.13,1.33-4.6c.82-2.94,1.71-5.55,2.43-7.87s1.41-4.28,2-5.89,1-2.82,1.32-3.7l.36-1c.08-.21.13-.32.13-.32a1.58,1.58,0,0,1-.08.34l-.31,1c-.29.89-.7,2.14-1.23,3.74s-1.21,3.59-1.9,5.91-1.56,4.94-2.35,7.88c-.42,1.47-.85,3-1.3,4.61s-.85,3.29-1.3,5c-.92,3.46-1.74,7.21-2.64,11.13-1.69,7.88-3.29,16.6-4.57,25.82s-2,18-2.49,26.08c-.18,4-.4,7.85-.43,11.44,0,1.79-.09,3.52-.09,5.18s0,3.26,0,4.78c0,3.05.11,5.81.17,8.23s.15,4.5.24,6.2.15,3,.19,3.93c0,.42,0,.76,0,1A1.88,1.88,0,0,1,584.2,457.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.65,375.21s.08,0,.25-.1a2.42,2.42,0,0,1,.76,0,3.43,3.43,0,0,1,2.41,1.42,3.93,3.93,0,0,1,.24,4.1,5.25,5.25,0,0,1-1.6,1.93,5,5,0,0,1-2.55.89,4.14,4.14,0,0,1-2.63-.69,3.28,3.28,0,0,1-1.36-2.14,4.47,4.47,0,0,1,1.26-3.94c1.85-1.58,3.48-1.63,3.45-1.48s-.09,0-.25,0a4.16,4.16,0,0,0-.7.24,7.23,7.23,0,0,0-2.24,1.45,4.16,4.16,0,0,0-1.05,3.59,2.79,2.79,0,0,0,1.18,1.81,3.62,3.62,0,0,0,2.3.59,4.49,4.49,0,0,0,2.29-.79,4.55,4.55,0,0,0,1.47-1.72,3.58,3.58,0,0,0-.11-3.68,3.41,3.41,0,0,0-2.13-1.43A8,8,0,0,0,491.65,375.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.46,360.28c0,.11-1.7-.2-4.42.05A20.26,20.26,0,0,0,496.44,372c-1.17,2.47-1.45,4.16-1.56,4.14a4.72,4.72,0,0,1,.19-1.19,17,17,0,0,1,1-3.1A19.7,19.7,0,0,1,513,360a17.75,17.75,0,0,1,3.27.09A4.59,4.59,0,0,1,517.46,360.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.72,390.85a3.46,3.46,0,0,1,.39-.85,12.77,12.77,0,0,1,1.45-2.08,15.43,15.43,0,0,1,15.18-5.18,13.65,13.65,0,0,1,2.42.77,3.62,3.62,0,0,1,.83.43c0,.1-1.24-.47-3.32-.84a16.08,16.08,0,0,0-14.84,5.06C470.42,389.72,469.81,390.9,469.72,390.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.57,394.94a6.38,6.38,0,0,1-1.69-1.22,18.87,18.87,0,0,1-3.27-3.85,18.44,18.44,0,0,1-2.13-4.57,6,6,0,0,1-.41-2.05,36.91,36.91,0,0,0,3,6.34A38.71,38.71,0,0,0,501.57,394.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.23,376.6s.08-.05.25-.1a2.42,2.42,0,0,1,.76,0,3.47,3.47,0,0,1,2.41,1.42,4,4,0,0,1,.25,4.1,5.28,5.28,0,0,1-1.61,1.93,5,5,0,0,1-2.55.89,4.14,4.14,0,0,1-2.63-.69,3.32,3.32,0,0,1-1.36-2.14A4.47,4.47,0,0,1,544,378c1.85-1.57,3.48-1.63,3.45-1.48s-.09,0-.25.05a4.16,4.16,0,0,0-.7.24,7.23,7.23,0,0,0-2.24,1.45,4.16,4.16,0,0,0-1,3.59,2.83,2.83,0,0,0,1.18,1.81,3.62,3.62,0,0,0,2.3.59,4.49,4.49,0,0,0,2.29-.79,4.55,4.55,0,0,0,1.47-1.72,3.58,3.58,0,0,0-.11-3.68,3.41,3.41,0,0,0-2.13-1.43A8,8,0,0,0,547.23,376.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573,361.67c0,.11-1.7-.2-4.42.05A20.26,20.26,0,0,0,552,373.35c-1.17,2.47-1.45,4.16-1.56,4.14a4.72,4.72,0,0,1,.19-1.19,17,17,0,0,1,1-3.1,19.7,19.7,0,0,1,16.91-11.85,17.75,17.75,0,0,1,3.27.09A4.59,4.59,0,0,1,573,361.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.3,392.24a3.46,3.46,0,0,1,.39-.85,13.45,13.45,0,0,1,1.45-2.08,15.48,15.48,0,0,1,15.18-5.18,14.09,14.09,0,0,1,2.43.77,3,3,0,0,1,.82.44c0,.09-1.24-.48-3.32-.85a16.06,16.06,0,0,0-14.83,5.06C526,391.11,525.39,392.29,525.3,392.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.15,396.33a6.38,6.38,0,0,1-1.69-1.22,19.19,19.19,0,0,1-3.27-3.85,18.44,18.44,0,0,1-2.13-4.57,6,6,0,0,1-.41-2,37,37,0,0,0,3,6.33A38.71,38.71,0,0,0,557.15,396.33Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.12,447.21c-.33.07-1.74,1.5.27,3.77s14.13,8.48,16.36,4.77-3.15-6.29-3.15-6.29Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.43,443.21s12.5-1.38,17.6-.73c5.53.71,11.4-2.08,14.88-5.9a20,20,0,0,0,4.39-8.84l8-5.56s.86-18.91-11.75-15.86l-14.73.52s-29,4.8-33.48,8.41c0,0-5.46,5.31-7.05,7.36-.6.78-1.11,8.57,4.43,11.23,0,0-3.27,4.17-.39,6.53l1.35,1s-1.87,4.17-.11,5.36,15.67,5.41,19.62,2.66-.63-5.92-2.72-6.2",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.85,433.1a12.58,12.58,0,0,1,1.63.18c1.05.13,2.57.32,4.46.46.94.06,2,.12,3.08.14s2.29,0,3.56.09a7.32,7.32,0,0,1,3.83,1.21,4.24,4.24,0,0,1,1.87,3.85,3.27,3.27,0,0,1-1.12,2,5.62,5.62,0,0,1-1.89,1.05,17.07,17.07,0,0,1-3.91.73,35.26,35.26,0,0,1-6.69-.13c-1.89-.2-3.4-.45-4.44-.63a9,9,0,0,1-1.62-.34,11.44,11.44,0,0,1,1.64.14c1.06.12,2.58.31,4.46.46a37.93,37.93,0,0,0,6.6,0,17.13,17.13,0,0,0,3.79-.73,5.37,5.37,0,0,0,1.72-.95,2.8,2.8,0,0,0,.94-1.67,3.75,3.75,0,0,0-1.65-3.37,7.08,7.08,0,0,0-3.57-1.15c-1.22-.11-2.42-.07-3.53-.13s-2.16-.11-3.11-.21c-1.89-.18-3.4-.42-4.45-.62A8,8,0,0,1,241.85,433.1Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.83,424.07a10.53,10.53,0,0,1,1.63.18c1,.14,2.56.34,4.43.5s4.11.29,6.6.29a8.84,8.84,0,0,1,3.95.59,3.15,3.15,0,0,1,1.5,1.61,4.07,4.07,0,0,1,.21,2.24,5.38,5.38,0,0,1-2.53,3.47,8.68,8.68,0,0,1-3.8,1.23,37.72,37.72,0,0,1-6.65-.31l-4.44-.45a9.48,9.48,0,0,1-1.63-.24,10.75,10.75,0,0,1,1.64,0l4.46.29a41.51,41.51,0,0,0,6.57.19,8.26,8.26,0,0,0,3.58-1.19,4.85,4.85,0,0,0,2.28-3.12,3,3,0,0,0-1.43-3.31,8.38,8.38,0,0,0-3.71-.56c-2.51,0-4.75-.19-6.63-.4s-3.39-.47-4.43-.67A9.29,9.29,0,0,1,240.83,424.07Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.28,425.17a16.38,16.38,0,0,1-1.13-2.31,14.25,14.25,0,0,1-1.2-2.27c.1-.1,1,.72,1.66,2A4.31,4.31,0,0,1,247.28,425.17Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.52,407.08l-11.82-1.57s-33.4-6.81-33.73-5.93-2,1.19-.74,4.77,20.51,6.75,21.37,7.89,1.48,7.77,9,10.82,12.26,2,12.26,2",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.9,425.08l-.25.07-.77.11a18,18,0,0,1-3,0,26.12,26.12,0,0,1-4.63-.82,25.51,25.51,0,0,1-5.81-2.26,13.5,13.5,0,0,1-5.21-5.44,30.49,30.49,0,0,1-1.6-3.89,3.61,3.61,0,0,0-.22-.44,1.06,1.06,0,0,0-.35-.22,10.18,10.18,0,0,0-1-.35c-.7-.22-1.42-.41-2.16-.6-2.94-.77-6.05-1.51-9.23-2.44-1.59-.47-3.2-1-4.8-1.63a16,16,0,0,1-2.35-1.16,5.68,5.68,0,0,1-1.08-.85,2.41,2.41,0,0,1-.41-.61c-.11-.23-.14-.44-.22-.65a4.86,4.86,0,0,1-.16-2.73,3.21,3.21,0,0,1,.72-1.18,2.24,2.24,0,0,0,.33-.46s0,0,.08-.13a.35.35,0,0,1,.19-.12,1.12,1.12,0,0,1,.22,0h.35c1.74.11,3.39.4,5,.66,3.27.54,6.41,1.12,9.4,1.69,6,1.13,11.34,2.21,15.85,3.14,1.12.22,2.2.48,3.21.65l2.9.4,4.63.66,2.93.44.76.13.26.06a.79.79,0,0,1-.27,0l-.76-.07-2.95-.35-4.65-.57-2.91-.37c-1-.16-2.09-.4-3.22-.61l-15.87-3c-3-.55-6.13-1.13-9.39-1.66-1.63-.25-3.31-.54-5-.65h-.3l-.1,0s0,0,0,0,0-.08-.05-.12l0,0c.39.14.1,0,.19.09l0,0a2.05,2.05,0,0,1-.41.59,2.77,2.77,0,0,0-.62,1,4.4,4.4,0,0,0,.17,2.42,2.25,2.25,0,0,0,.52,1.06,5.26,5.26,0,0,0,1,.76,16.5,16.5,0,0,0,2.27,1.12c1.57.64,3.16,1.15,4.75,1.62,3.16.94,6.26,1.68,9.2,2.46.74.2,1.47.4,2.18.62a8.39,8.39,0,0,1,1.06.38,1.25,1.25,0,0,1,.54.38,2.41,2.41,0,0,1,.27.53,30.17,30.17,0,0,0,1.57,3.86,13.06,13.06,0,0,0,5,5.32,25.58,25.58,0,0,0,5.7,2.3,26.29,26.29,0,0,0,4.57.89,20.21,20.21,0,0,0,2.94.1c.34,0,.6,0,.77,0Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.79,442.62a3.85,3.85,0,0,1,1.23.06,11.81,11.81,0,0,1,3.22.95,10.6,10.6,0,0,1,2,1.2,3.56,3.56,0,0,1,1.48,2.32,2.87,2.87,0,0,1-1.48,2.64,5.55,5.55,0,0,1-3.18.66,59.63,59.63,0,0,1-10.91-1.61c-1.37-.35-2.46-.71-3.2-1a5.66,5.66,0,0,1-1.13-.49,5.73,5.73,0,0,1,1.19.29c.76.22,1.85.52,3.22.82a70.77,70.77,0,0,0,10.85,1.45,5.12,5.12,0,0,0,2.89-.57,2.39,2.39,0,0,0,1.27-2.17,3.13,3.13,0,0,0-1.27-2,10,10,0,0,0-1.91-1.2A17.46,17.46,0,0,0,253.79,442.62Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.74,374.35s14.81-24.38,18.14-40.47S379.41,292.26,385,285.6s27.75-14.42,27.75-14.42l8.18-4.42,63.39-5.57s42.17,4.44,54.94,16.09S562,315.57,562,328.88s12.89,128.64,12.89,128.64l-156.21-.2,3.5-56.86s-18.87-12.76-23.86-23.86-2.22-5.55-2.22-5.55-17.71,37.65-23.81,42.09-77.05,26.21-77.05,26.21l-9.71-37.23Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.17,281.93c-1.71.53-22.87,55.18-24.36,60.15s0,36.29,0,36.29l7,12.93s-2,9.44-.5,13.92l-31.32,6s-7.95-5.47-15.41,0l-37,3.13s10.85.12,7.62,16.76c-3.16,16.3-5.57,19.88-5.57,19.88l129.85-3s14.43-.72,12.23-28.46-8.39-104.26-8.39-104.26S549.86,274.27,525.17,281.93Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.52,374a2.88,2.88,0,0,1-.31-.67l-.79-2c-.34-.85-.75-1.9-1.15-3.15s-.93-2.64-1.35-4.23-1-3.32-1.39-5.21-.86-3.91-1.26-6a110.52,110.52,0,0,1-1.53-14.09,113.38,113.38,0,0,1,.43-14.17c.26-2.16.47-4.22.82-6.13.16-1,.29-1.88.47-2.77s.36-1.72.53-2.53c.32-1.61.73-3,1.06-4.32s.64-2.34.93-3.22.49-1.5.65-2a7.27,7.27,0,0,1,.26-.7,3,3,0,0,1-.16.73c-.14.51-.33,1.19-.56,2s-.56,2-.84,3.24-.69,2.7-1,4.32c-.16.81-.32,1.65-.49,2.53s-.29,1.8-.44,2.75c-.33,1.91-.53,4-.77,6.12a106.24,106.24,0,0,0,1.09,28.12c.39,2.14.75,4.17,1.21,6s.89,3.62,1.32,5.21.9,3,1.28,4.24.75,2.31,1.06,3.17l.7,2A6,6,0,0,1,500.52,374Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.7,433.27s-.13-.12-.34-.38l-.86-1.15c-.37-.51-.83-1.12-1.39-1.8s-1.17-1.49-1.92-2.32-1.54-1.76-2.46-2.69-1.92-1.92-3-2.93a74.19,74.19,0,0,0-7.48-6,75,75,0,0,0-8.24-4.88c-1.33-.64-2.58-1.27-3.8-1.76s-2.34-1-3.38-1.35-2-.69-2.85-1-1.57-.5-2.17-.66l-1.38-.41a1.81,1.81,0,0,1-.48-.18,2.22,2.22,0,0,1,.5.08l1.41.31c.61.14,1.35.32,2.21.58s1.83.52,2.88.92,2.22.77,3.43,1.29,2.5,1.1,3.84,1.73a69.18,69.18,0,0,1,8.33,4.88,71.26,71.26,0,0,1,7.5,6.06c1.07,1,2.09,2,3,3s1.71,1.89,2.43,2.75,1.32,1.68,1.87,2.38,1,1.34,1.32,1.86.58.88.79,1.21A2.06,2.06,0,0,1,545.7,433.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.63,426c-.08.07-1.23-1.24-3.39-3a34.36,34.36,0,0,0-4-2.8,38.09,38.09,0,0,0-5.39-2.61,37.65,37.65,0,0,0-5.76-1.62,34.71,34.71,0,0,0-4.86-.57c-2.79-.11-4.52.1-4.53,0a5.38,5.38,0,0,1,1.21-.2,12.36,12.36,0,0,1,1.43-.13c.56,0,1.19-.07,1.9,0a31.83,31.83,0,0,1,4.94.47,34.63,34.63,0,0,1,5.85,1.61,34.26,34.26,0,0,1,5.46,2.68,31.57,31.57,0,0,1,4,2.92c.55.45,1,.91,1.39,1.3a11.24,11.24,0,0,1,1,1A5.6,5.6,0,0,1,556.63,426Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.62,407.71c-.06.09-1.59-1.13-4.39-2.51a22.74,22.74,0,0,0-2.34-1c-.84-.36-1.78-.63-2.76-.94a31.66,31.66,0,0,0-13.27-.91c-1,.17-2,.31-2.86.55a23.71,23.71,0,0,0-2.46.7c-3,1-4.64,2-4.69,1.88a6.53,6.53,0,0,1,1.17-.71,11.78,11.78,0,0,1,1.43-.72,20.53,20.53,0,0,1,2-.8,21.31,21.31,0,0,1,2.47-.76,27.81,27.81,0,0,1,2.9-.62,30.48,30.48,0,0,1,13.47.93,24.42,24.42,0,0,1,2.79,1,20.73,20.73,0,0,1,2.35,1.09,19.62,19.62,0,0,1,1.84,1.07,10.62,10.62,0,0,1,1.32.9A5.79,5.79,0,0,1,544.62,407.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.68,448.69a46.75,46.75,0,0,0,.92-5.56,35.92,35.92,0,0,0-.05-6.11,48.76,48.76,0,0,0-1.3-7.37,51.67,51.67,0,0,0-2.49-7,38.66,38.66,0,0,0-3-5.34,51,51,0,0,0-3.53-4.41,9.57,9.57,0,0,1,1.15,1,12.77,12.77,0,0,1,1.22,1.32l.72.85c.25.32.48.66.74,1a34.64,34.64,0,0,1,3.1,5.35A43.24,43.24,0,0,1,470,437a33.82,33.82,0,0,1-.06,6.18c-.05.44-.1.85-.14,1.25l-.22,1.1a11.43,11.43,0,0,1-.42,1.74A9.53,9.53,0,0,1,468.68,448.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.91,411.16a1,1,0,0,1-.06-.29c0-.22-.08-.5-.14-.85-.11-.79-.27-1.89-.47-3.29-.41-2.86-.94-7-1.56-12.14-1.23-10.25-2.7-24.45-3.85-40.17s-1.75-30-2-40.31c-.14-5.16-.21-9.34-.23-12.23,0-1.41,0-2.53,0-3.32v-.87a.15.15,0,1,1,.06,0c0,.23,0,.51,0,.87,0,.79.06,1.9.11,3.32.09,2.92.22,7.09.38,12.22.37,10.32,1,24.57,2.17,40.29s2.56,29.9,3.7,40.16c.58,5.1,1.06,9.24,1.39,12.15.16,1.41.28,2.51.37,3.31,0,.35.07.63.09.86A1.59,1.59,0,0,1,446.91,411.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.9,371.77a11.41,11.41,0,0,1-.68-1.53c-.4-1-1-2.43-1.75-4.2-1.5-3.53-3.74-8.34-6.42-13.56s-5.1-9.85-6.91-13.33c-.87-1.72-1.57-3.11-2-4.08a10.92,10.92,0,0,1-.67-1.54,9.27,9.27,0,0,1,.85,1.44l2.17,4c1.82,3.38,4.38,8,7.06,13.27s4.87,10.07,6.29,13.65c.71,1.79,1.26,3.25,1.6,4.27A10.61,10.61,0,0,1,395.9,371.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.92,353.29a3.06,3.06,0,0,1-.91-.17c-.57-.14-1.39-.38-2.4-.71a59.23,59.23,0,0,1-14.78-7.32c-.87-.6-1.56-1.11-2-1.48a3.56,3.56,0,0,1-.68-.61,32.61,32.61,0,0,1,2.91,1.78c1.78,1.12,4.28,2.59,7.16,4s5.56,2.52,7.53,3.26A33.85,33.85,0,0,1,387.92,353.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.51,387.44a5.39,5.39,0,0,1-1.08-.65c-.66-.45-1.64-1.09-2.87-1.83a59.14,59.14,0,0,0-20.91-7.83c-1.42-.25-2.57-.41-3.37-.51a5.5,5.5,0,0,1-1.24-.21,5.54,5.54,0,0,1,1.26,0c.8,0,2,.14,3.41.34a52.55,52.55,0,0,1,11,2.8,53.17,53.17,0,0,1,10.1,5.08c1.21.8,2.16,1.48,2.79,2A6.85,6.85,0,0,1,374.51,387.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.63,261.28a8.06,8.06,0,0,1-.06.81c-.07.58-.16,1.35-.27,2.32-.26,2-.62,4.92-1.23,8.5a107.72,107.72,0,0,1-2.8,12.44A58,58,0,0,1,472,299.63a43.78,43.78,0,0,1-5.21,6.68l-.2.22-.19-.25a26.45,26.45,0,0,0-9.49-7.87,25.22,25.22,0,0,0-5-1.84,22.13,22.13,0,0,0-4.55-.61,18.77,18.77,0,0,0-6.48.91c-1.45.51-2.22.89-2.24.84a3.6,3.6,0,0,1,.55-.29,13.55,13.55,0,0,1,1.63-.72,18.16,18.16,0,0,1,6.55-1.07,22.09,22.09,0,0,1,4.64.56,25.49,25.49,0,0,1,5.1,1.82,26.65,26.65,0,0,1,9.7,8l-.39,0a44.48,44.48,0,0,0,5.14-6.6,58.91,58.91,0,0,0,6.27-14.14,117.36,117.36,0,0,0,2.9-12.36c.66-3.56,1.07-6.47,1.39-8.47.15-1,.28-1.73.37-2.3A3.56,3.56,0,0,1,482.63,261.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "483.48 261.91 473.85 249.14 463.38 249.47 429.36 267.44 483.48 261.91",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.62,297.71a2.3,2.3,0,0,1-.55,0,12.18,12.18,0,0,1-1.57-.26,19.49,19.49,0,0,1-5.37-2.3,11.78,11.78,0,0,0-3.65-1.51,10.75,10.75,0,0,0-4.52,0,10.57,10.57,0,0,0-7.55,6.57l-.54,1.46,0-1.56c0-.39,0-.8,0-1.22.12-7.88.13-15,.45-20.19.15-2.58.35-4.67.57-6.1.09-.72.2-1.27.28-1.64a3.44,3.44,0,0,1,.14-.56c.05,0-.09.79-.22,2.23s-.3,3.51-.4,6.09c-.23,5.16-.17,12.29-.3,20.18,0,.42,0,.84,0,1.23l-.5-.1a11,11,0,0,1,7.94-6.85,11.22,11.22,0,0,1,8.44,1.67,21.13,21.13,0,0,0,5.24,2.42C437.86,297.61,438.63,297.66,438.62,297.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.85,187.3V264a18.6,18.6,0,0,1-4.37,12h0a56.45,56.45,0,0,1-15.4,12.75l-15.46,8.71L425.82,286a18.63,18.63,0,0,1-6.19-13.15c-.22-5.58-.22-11.21-.22-11.21s-21.67-1.56-23.71-22.93c-1-10.06-1.26-30.67-1.31-49.67a41.58,41.58,0,0,1,38.15-41.53l.61-.05A39.74,39.74,0,0,1,473.85,187.3Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.35,261.32s13.61,0,27.24-10.24c0,0-5.32,15.94-26.83,15.78Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.59,203.39a3.07,3.07,0,0,0,3.2,2.84,2.93,2.93,0,0,0,2.92-3,3.06,3.06,0,0,0-3.19-2.84A2.93,2.93,0,0,0,401.59,203.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.85,197.65c.41.36,2.58-1.54,5.87-1.8s5.84,1.18,6.16.75c.16-.2-.28-.88-1.4-1.56a8.37,8.37,0,0,0-5-1.09,8,8,0,0,0-4.63,1.93C399.93,196.74,399.65,197.48,399.85,197.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.87,202.06a3.07,3.07,0,0,0,3.2,2.84,2.94,2.94,0,0,0,2.93-3,3.07,3.07,0,0,0-3.2-2.84A2.94,2.94,0,0,0,432.87,202.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.22,195.59c.41.36,2.59-1.54,5.87-1.8s5.84,1.18,6.16.74c.16-.19-.28-.88-1.4-1.55a8.44,8.44,0,0,0-5-1.1,8.06,8.06,0,0,0-4.63,1.93C432.3,194.67,432,195.42,432.22,195.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.3,221c0-.19-2.07-.38-5.42-.53-.84,0-1.65-.11-1.84-.67a4.32,4.32,0,0,1,.35-2.54c.63-2.1,1.28-4.29,2-6.6,2.69-9.39,4.57-17.08,4.19-17.18s-2.87,7.42-5.56,16.8c-.65,2.32-1.27,4.52-1.85,6.63a4.83,4.83,0,0,0-.16,3.33,2.1,2.1,0,0,0,1.48,1.12,5.65,5.65,0,0,0,1.44.08C420.24,221.3,422.31,221.14,422.3,221Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.17,222.43c-.54,0-.25,3.58-3.1,6.37s-6.67,2.71-6.66,3.21c0,.22.91.62,2.52.53a8.89,8.89,0,0,0,5.57-2.48,7.72,7.72,0,0,0,2.37-5.32C432.88,223.24,432.41,222.39,432.17,222.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.3,182.77c.4.87,3.65.17,7.54.32s7.11.94,7.55.09c.2-.4-.41-1.19-1.74-2a13.14,13.14,0,0,0-11.5-.31C430.78,181.6,430.13,182.36,430.3,182.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.27,188c.64.7,2.84-.26,5.56-.52s5.07.08,5.54-.74c.2-.4-.22-1.12-1.29-1.74a7.76,7.76,0,0,0-4.63-.85,7.64,7.64,0,0,0-4.31,1.87C400.24,186.89,400,187.69,400.27,188Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.68,165.76l.12.08A16.93,16.93,0,0,1,456,176.21l.09.43c1.34,6,1.71,12.25,3.11,18.27s1.14,10.62,7.17,12a8,8,0,0,0,8.39-3.41,5.14,5.14,0,0,0,.53-2.86c-.07-14.82,2.91-20.58,1.6-36a13,13,0,0,0-6.26-10.12c-3.42-2.05-7.56-4.12-11-2.13s-7.53,9.09-10.08,12.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.43,197.57c.36-.18,14.34-5.56,15.09,9.11s-14.14,12.38-14.18,12S467.43,197.57,467.43,197.57Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.54,212.86c.06-.05.26.17.7.34a2.54,2.54,0,0,0,1.91-.06c1.52-.64,2.7-3.17,2.64-5.82a8.41,8.41,0,0,0-.9-3.62,2.94,2.94,0,0,0-2-1.86,1.29,1.29,0,0,0-1.47.78c-.18.42-.07.7-.15.73s-.32-.23-.24-.84a1.68,1.68,0,0,1,.53-.95,2,2,0,0,1,1.4-.44,3.6,3.6,0,0,1,2.78,2.14,8.63,8.63,0,0,1,1.09,4c.06,3-1.31,5.8-3.4,6.52a2.73,2.73,0,0,1-2.36-.27C472.58,213.21,472.49,212.89,472.54,212.86Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.27,154.6c3.12-6.15-7.44-13.74-14.85-15.42s-16.63,2.63-23.61,5.61c-4.41,1.88-8.75,4.35-13.54,4.54-3.21.14-6.36-.77-9.47-1.59s-6.33-1.56-9.51-1.07-6.33,2.45-7.29,5.52,1.1,7,4.31,7.16c-4.23-1.89-9.85,1.51-10.12,6.14s4.88,8.68,9.31,7.33c-2.21-1.41-5.19,1.46-4.71,4s3,4.28,5.45,5.13c6.33,2.17,13.37.73,19.51-1.92s11.71-6.44,17.78-9.24,16.22-7.76,22.68-6.07c4.76,1.25,8.44,6.56,11,5.11a9,9,0,0,0,4.08-7,25.7,25.7,0,0,0-1-8.3",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.51,159.09c.12-.08.84,1,2.56,2.6a20.21,20.21,0,0,0,8.56,4.55,18.59,18.59,0,0,0,13.9-1.71c4.79-2.64,8.68-7.46,13.23-12.06s10.05-8.26,15.79-9.26,11.18.64,14.38,3.68a12.85,12.85,0,0,1,4.11,9.18,10.18,10.18,0,0,1-.41,2.75c-.22.59-.36.89-.41.87a22.82,22.82,0,0,0,.25-3.6,12.63,12.63,0,0,0-4.22-8.44c-3-2.7-8.14-4.15-13.46-3.13s-10.57,4.44-15,9-8.47,9.45-13.6,12.21a20,20,0,0,1-23.51-3.61,14.32,14.32,0,0,1-1.71-2.15C384.62,159.41,384.47,159.12,384.51,159.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.11,196.63c-.05.05-.67-.35-1.32-1.47a9.84,9.84,0,0,1-1.16-5.24c-.07-4.74,3.68-10.14,3.67-16.69a14.76,14.76,0,0,0-2.34-8.6,11.28,11.28,0,0,0-5.83-4.25,9.54,9.54,0,0,0-4.94-.26c-1.16.29-1.76.61-1.83.5s.48-.56,1.67-1a9.24,9.24,0,0,1,5.38-.19,11.89,11.89,0,0,1,6.64,4.47,15.57,15.57,0,0,1,2.7,9.38,26.72,26.72,0,0,1-2.06,9.45,27.91,27.91,0,0,0-2,7.29C469.23,194.33,471.31,196.54,471.11,196.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.76,
    y: 201.98,
    width: 7.53,
    height: 17.43,
    rx: 2.14,
    transform: "translate(269.11 -265.01) rotate(42.82)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.06,332.17s0,.2.06.59.07,1,.13,1.72c.11,1.53.26,3.78.47,6.7.4,5.88,1,14.47,1.71,25.36S566,390.62,567,405.69q.36,5.65.76,11.65c.15,2,.23,4,.32,6.1a29.36,29.36,0,0,1,0,3.11,30.22,30.22,0,0,1-.17,3.15l-.39,3.18c-.23,1.05-.46,2.11-.68,3.17s-.66,2.08-1,3.13-.84,2.05-1.38,3c-2.1,3.89-5.37,7.53-9.91,9h-.06l-97.83,0-31,0h-.34l.09-.33c.95-3.38,1.89-6.72,2.82-10.05q.71-2.49,1.39-5a34.53,34.53,0,0,0,1.16-4.93,21.43,21.43,0,0,0-.86-9.82,12,12,0,0,0-2.34-4.22,6.88,6.88,0,0,0-4-2.35l-2.05-.32,2-.17,36.95-3.1-.11,0a12.62,12.62,0,0,1,8-2.45,16,16,0,0,1,7.71,2.46l-.17,0L507.24,405l-.14.24a13.13,13.13,0,0,1-.54-3.69,30.1,30.1,0,0,1,.1-3.57,55.29,55.29,0,0,1,.95-6.76v.12c-2.51-4.69-4.81-9-6.94-12.94v-.06c-.49-11.53-.67-20.62-.58-26.82,0-3.1.15-5.48.31-7.08a12.1,12.1,0,0,1,.27-1.8c.09-.4.14-.6.14-.6s0,.21-.1.61a13.3,13.3,0,0,0-.23,1.8c-.14,1.6-.23,4-.24,7.07,0,6.2.18,15.29.71,26.81v-.06c2.13,3.95,4.45,8.23,7,12.91l0,0v.06A56.51,56.51,0,0,0,507,398a29.73,29.73,0,0,0-.09,3.54,12.88,12.88,0,0,0,.53,3.58l.06.2-.2,0-31.32,6-.08,0-.08-.05a15.45,15.45,0,0,0-7.48-2.36,12.08,12.08,0,0,0-7.67,2.37l-.06,0h-.06l-36.94,3.14v-.49a7.33,7.33,0,0,1,4.32,2.5,12.61,12.61,0,0,1,2.44,4.4,21.89,21.89,0,0,1,.89,10.05,34.24,34.24,0,0,1-1.17,5q-.69,2.48-1.39,5-1.4,5-2.81,10l-.25-.33,31,0,97.83.07h0a15,15,0,0,0,5.67-3.5,21.12,21.12,0,0,0,3.95-5.29c.53-1,.91-2,1.36-3s.68-2.06,1-3.09.45-2.09.68-3.13.26-2.11.39-3.15a29.82,29.82,0,0,0,.18-3.12,29,29,0,0,0,0-3.09c-.09-2.05-.16-4.07-.31-6.07q-.37-6-.74-11.66c-1-15.07-1.79-28.27-2.48-39.17s-1.21-19.48-1.58-25.36c-.17-2.92-.31-5.18-.4-6.71,0-.75-.07-1.32-.09-1.72S562.06,332.17,562.06,332.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.74,277.68a19.14,19.14,0,0,1-1.78,1.11,41.65,41.65,0,0,0-4.63,3.32,54.32,54.32,0,0,0-12,14.34,118.46,118.46,0,0,0-8,17l-2.08,5.32-.58,1.45a2.11,2.11,0,0,1-.23.49,2,2,0,0,1,.13-.53c.13-.39.3-.88.49-1.48.44-1.28,1.08-3.12,1.93-5.39a107.18,107.18,0,0,1,7.89-17.15,52.08,52.08,0,0,1,12.2-14.36,35.46,35.46,0,0,1,4.76-3.2c.58-.35,1.07-.56,1.38-.72A2.49,2.49,0,0,1,533.74,277.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M494.6,315.87A66.38,66.38,0,0,0,489,345.78c.38,10.16,1.6,20.35.6,30.48s-4.51,20.46-12.06,27.27a9.81,9.81,0,0,0-2.44,2.71,2.75,2.75,0,0,0,.47,3.35,4,4,0,0,0,3.14.33c7.23-1.26,14.55-2.16,21.79-3.41,1.55-.27,6.76-1.29,6.76-1.29a28.28,28.28,0,0,1-.44-6c.23-1.81.94-8,.94-8a10.64,10.64,0,0,0-1.39-2.58,59.15,59.15,0,0,1-6-15.39c-2.47-5.05-3.58-10.13-4.73-14.85-3.17-13.11-3.08-26-1.06-42.61"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M415.33,300.94c.59,1.5,1.19,3,1.78,4.51a1.82,1.82,0,0,0,.86,1.13c.89.34,1.6-.75,2-1.61a11.55,11.55,0,0,1,8.87-6.23c3-.35,6.16.53,9.15-.09a40.54,40.54,0,0,0-8.26-4.11,13.7,13.7,0,0,0-9.07-.09,8.37,8.37,0,0,0-5.47,6.83"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M440.05,297.15a48.72,48.72,0,0,1,10.59,1,16.52,16.52,0,0,1,9.07,5.22c2.42,2.95,3.32,6.82,4.3,10.5.19.71.53,1.55,1.25,1.63a1.78,1.78,0,0,0,1.2-.47c6-4.4,9.94-11.13,12.1-18.23s2.66-14.58,2.78-22c-2.86,5.11-4.1,10.93-6,16.47s-4.67,11.12-9.57,14.32a4.78,4.78,0,0,0-1.12-3.51,10.48,10.48,0,0,0-2.91-2.38,27.8,27.8,0,0,0-22.26-2.73"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M424.51,414.94H412.26s-27.63-10-33.31-9c-5.12.86-23.85,13.3-27.52,15.77a2.31,2.31,0,0,0-.89,1.13h0a4,4,0,0,0,2.24,5.1l.38.16-.16.56a6.63,6.63,0,0,0-.29,2.24,2.7,2.7,0,0,0,5,1.16l-.7,1.26a3,3,0,0,0-.39,1.68l.06,1.13a3.08,3.08,0,0,0,2.12,2.76h0A3.07,3.07,0,0,0,362,438c2.38-2.61,7.51-7.84,11-8.42a81.13,81.13,0,0,1,11.34-.57,3.85,3.85,0,0,1,3.57,2.45h0c-2.06.15-16.42,7.64-21.5,10.32a5.41,5.41,0,0,0-2.95,4.09c-.19,1.59.61,3.25,3.76,2.52,6.75-1.58,18.9-7.16,18.9-7.16s6.26-1.79,10.32,1.07c5.71,4,8.33,5.51,13.23,3.88a41.54,41.54,0,0,0,8.52-4l9.66-1S437,418.44,424.51,414.94Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,419.6c0,.11-2-.51-5.19-.72a26.78,26.78,0,0,0-22.33,9.53,51.66,51.66,0,0,0-3.07,4.25,6.1,6.1,0,0,1,.61-1.28,23.23,23.23,0,0,1,2.17-3.2,25.94,25.94,0,0,1,22.65-9.66,24,24,0,0,1,3.81.64A6.5,6.5,0,0,1,388,419.6Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.1,412.89a21,21,0,0,0-18,2.62A50.36,50.36,0,0,0,357,424.08L354.22,427a7.13,7.13,0,0,1-1.06,1,9.63,9.63,0,0,1,.91-1.18c.61-.74,1.51-1.79,2.66-3.06a46.54,46.54,0,0,1,10.13-8.77,23,23,0,0,1,12.85-3.48,15.44,15.44,0,0,1,4,.74,9,9,0,0,1,1,.39Z",
    style: {
      fill: "#eb996e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.74,457.81l-33.18-83.29a10.89,10.89,0,0,1,10.08-15H332a10.89,10.89,0,0,1,10.31,7.39l28.5,84,33.29.16c2.7,0,4.89,4,4.89,6.67h0l-36.64-.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.55,378.75a11.56,11.56,0,0,0-6.68,1.79,8.7,8.7,0,0,0-1.82,1.51c-1.77,2-4.93,5.86-3.67,11.9s5.15,6.87,7,7.07,14.52-3.41,14.52-3.41,4.6-3.91,3-9.05C263.43,384.15,259.35,379,252.55,378.75Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.49,399.22s.46,3.23,2.08,4,4.64.67,7,.09,5.76-1.9,6.16-3.69a7.53,7.53,0,0,0-.2-4.21,10.55,10.55,0,0,0-8.52-.79A11.26,11.26,0,0,0,246.49,399.22Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.78,383.8a6.08,6.08,0,1,1-7.38-4.42A6.09,6.09,0,0,1,256.78,383.8Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.43,397a7.8,7.8,0,0,0,1.73-5.16A7.6,7.6,0,0,0,240.9,387a14.92,14.92,0,0,0-.66,6.15A11.11,11.11,0,0,0,241.43,397Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.2,391.05a7.73,7.73,0,0,1-3.95-3.73,6.87,6.87,0,0,1-.39-5.09,16.89,16.89,0,0,1,3.45,4.85C265.49,389.87,265.2,391.05,265.2,391.05Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.52,412.09a6.72,6.72,0,1,1-6.72-6.71A6.72,6.72,0,0,1,299.52,412.09Z",
    style: {
      fill: "#f5f5f5"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentMan);
export default __webpack_public_path__ + "static/media/contentMan.14daeceb7dd1a49683d5867cdd206f80.svg";
export { ForwardRef as ReactComponent };